module.exports = __webpack_public_path__ + "static/media/q_type_6.9fbef678.png";